import { type UseMediaQueryOptions, useMediaQuery, useTheme } from '@mui/material';
import { DeliveryProviderPortalService } from '../api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal';

export type DeviceType = DeliveryProviderPortalService.DeviceType;

const options: UseMediaQueryOptions = {
  noSsr: true,
};

export const deviceBreakpoints = {
  mobile: 0,
  tablet: 472,
  laptop: 720,
  desktop: 1200,
};

// TODO(DPX-3850): Clean up.
export function useIsMaxWidth(width: number) {
  return useMediaQuery(`(max-width: ${width}px)`, options);
}

export function useIsDesktop(): boolean {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.up(deviceBreakpoints.desktop), options);
}

export function useIsTabletOrLower(): boolean {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down(deviceBreakpoints.laptop), options);
}

export function useIsMobile(): boolean {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down(deviceBreakpoints.tablet), options);
}

export function useDeviceType(): DeviceType {
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

  if (isDesktop) {
    return DeliveryProviderPortalService.DeviceType.DESKTOP;
  }

  if (isMobile) {
    return DeliveryProviderPortalService.DeviceType.MOBILE;
  }

  return DeliveryProviderPortalService.DeviceType.TABLET;
}
